export class PaginationResponse<T> {
  constructor(
    public currentElements: T[],
    public currentPage: number,
    public numberOfElements: number
  ) { }
}
